'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _componentThemes$form = _themes.componentThemes.form,
  errorStyle = _componentThemes$form.errorStyle,
  formTheme = _componentThemes$form.formTheme;
var errorStyles = function errorStyles(props) {
  var theme = formTheme(props.theme);
  return {
    color: theme[errorStyle('color')],
    paddingTop: theme.space_xs,
    marginTop: props.collapsePaddingAbove ? '-3rem' : 'unset'
  };
};
exports.default = (0, _glamorous2.default)('div')(errorStyles);